// Holds the current user's tenant config. Populated by fetchTenantConfig()
// dispatched from getLoggedinUserAction after login. When `config` is null
// the sidebar falls back to legacy REACT_APP_ENABLE_* env vars so the app
// keeps working through deploy windows where the backend route isn't live yet.

import {
  TENANT_CONFIG_REQUEST,
  TENANT_CONFIG_SUCCESS,
  TENANT_CONFIG_FAIL,
  TENANT_CONFIG_RESET,
} from '../constants/tenantConfigConstants';

const initialState = { loading: false, config: null, error: null };

export const tenantConfigReducer = (state = initialState, action) => {
  switch (action.type) {
    case TENANT_CONFIG_REQUEST:
      return { ...state, loading: true, error: null };
    case TENANT_CONFIG_SUCCESS:
      return { loading: false, config: action.payload, error: null };
    case TENANT_CONFIG_FAIL:
      return { ...state, loading: false, error: action.payload };
    case TENANT_CONFIG_RESET:
      return initialState;
    default:
      return state;
  }
};
